<mat-toolbar fxLayout="row" fxLayoutAlign="start center">
    <strong>Add New Unit</strong>
</mat-toolbar>

<form [formGroup]="formGroup">
    <div fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between start">

            <lgd-text fxFlex="40" controlName="code" label="Code" telemetry="Edit-Code-AddNewUnit-Inventory">
            </lgd-text>

            <lgd-text fxFlex="40" controlName="description" label="Description" telemetry="Edit-Description-AddNewUnit-Inventory" style="margin: 0 1rem;">
            </lgd-text>

            <lgd-number fxFlex="40" controlName="conversionFactor" label="Conversion Factor" telemetry="Edit-ConversionFactor-AddNewUnit-Inventory">
            </lgd-number>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between">
            <div fxFlex="40"></div>
            <div>{{getConversionString()}}</div>
        </div>
    </div>

    <mat-progress-bar [fxShow]="saving" mode="indeterminate"></mat-progress-bar>
</form>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end start">
    <command-bar [commands]="commands" telemetry="CmdBar-CommandKey-AddNewUnit-Inventory"></command-bar>
</div>
